import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import { 
  signatureLocationIcon,
  signatureLocationIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class SignatureLocationButton extends Component {
  
  toggleSignatureLocation = (e) => {
    const {
      routeId, stopId, enableSignatureLocationAction, 
      disableSignatureLocationAction, signatureLocationIsEnabled,
      addSignatureLocationToMapAction, removeSignatureLocationFromMapAction
    } = this.props;
    e.stopPropagation();
    removeSignatureLocationFromMapAction(routeId, stopId);
    if (signatureLocationIsEnabled) {
      disableSignatureLocationAction(routeId, stopId);
    } else {
      enableSignatureLocationAction(routeId, stopId);
      addSignatureLocationToMapAction(routeId, stopId);    
    }
  }

  componentDidMount = () => {
    const {
      routeId, stopId, signatureLocationIsEnabled, 
      addSignatureLocationToMapAction 
    } = this.props;
    if (signatureLocationIsEnabled) {
      addSignatureLocationToMapAction(routeId, stopId);
    }
  }

  render() {
    const { signatureLocationIsEnabled, ...others } = this.props;
    return (
      <ButtonWithIcon
      label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.zones.signatureLocation')}
      isActive={signatureLocationIsEnabled} 
      iconUrl={signatureLocationIcon}
      activeIconUrl={signatureLocationIconActive}
      onClick={this.toggleSignatureLocation}
      {...others}/>
    );
  }
}

SignatureLocationButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  signatureLocationIsEnabled: PropTypes.bool.isRequired,
  enableSignatureLocationAction: PropTypes.func.isRequired,
  disableSignatureLocationAction: PropTypes.func.isRequired,
  addSignatureLocationToMapAction: PropTypes.func.isRequired,
  removeSignatureLocationFromMapAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  signatureLocationIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'signatureLocationIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableSignatureLocationAction: bindActionCreators(actions.enableSignatureLocation, dispatch),
  disableSignatureLocationAction: bindActionCreators(actions.disableSignatureLocation, dispatch),
  addSignatureLocationToMapAction: bindActionCreators(actions.addSignatureLocationToMap, dispatch),
  removeSignatureLocationFromMapAction: bindActionCreators(actions.removeSignatureLocationFromMap, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SignatureLocationButton);

